<main>
    <div class="admin_events_left">
        <div class="main_menu">
            <img (click)="go('/accueil/profil')" class="menus_avatar" src="{{imgUrl}}" alt="avatar">
            <p class="menus_name">
                <b>{{userData.username}}</b>
            </p>
            <div class="menus_tabs">
                <div class="menus_tab">
                    <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
                </div>
                <div class="menus_tab menu_rapports" (click)="go('/admin')">
                    <p>Rapports</p>
                </div>
                <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                    <p>Évènements</p>
                </div>
                <div class="menus_deconnexion" (click)="signOut()">
                    <p style="color: red; font-weight: 500;
                        position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
                </div>
            </div>
        </div>
        <div class="mobile_menu">
            <img (click)="manageDropDown()" class="menus_avatar" src="../../../assets/icons/default_avatar.svg" alt="avatar">
            <div class="menus_tabs">
                <div class="menus_tab">
                    <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
                </div>
                <div class="menus_tab menu_accueil" (click)="go('/admin')">
                    <p>Rapports</p>
                </div>
                <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                    <p>Évènements</p>
                </div>
            </div>
            <div class="menu_dropdown">
                <hr>
                <p class="dropdown_profil" (click)="go('/accueil/profil')">
                    {{userData.username}} -&emsp;
                </p>
                <p (click)="signOut()" style="color: red; font-weight: 500;
                        position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
            </div>
        </div>
    </div>
    <div class="admin_events_right">
        <h4>Liste des évènements</h4>
        <div class="admin_right_ctn">
            <div class="button_create_evts_ctn">
                <button (click)="go('/admin/evenements/creer')">Créer un évènement</button>
            </div>
            <div class="events_list_ctn">
                <table class="excel-table">
                    <tr style="color: white;background-color: black;">
                        <td>Nom de l'évènement</td>
                        <td>Début</td>
                        <td>Fin</td>
                        <td>Créer par</td>
                        <td>Actions</td>
                    </tr>
                    <tr *ngFor="let event of evenements" class="event_{{event.isActive}}">
                        <td>{{event.nom}}</td>
                        <td>{{event.dateStart}}</td>
                        <td>{{event.dateEnd}}</td>
                        <td>{{event.createdBy}}</td>
                        <td>
                            <span (click)="manageModifyModal(event.eventId)" style="cursor: pointer;" class="material-icons">edit</span>
                            <span (click)="manageDeleteModal(event.eventId)" style="color: red; cursor: pointer;" class="material-icons">delete</span>
                        </td>
                    </tr>
                </table>  
            </div>
        </div>
        <div class="modifyModal_ctn">
            <div class="modifyModal">
                <h3>Modifier les dates de l'évènement <b>{{evenement.name}}</b></h3>
                <div class="dates_ctn">
                    <label for="admin_event_debut">
                        <p>Début: </p>
                        <input [(ngModel)]="dateDebut" type="date" name="admin_event_debut" id="admin_event_debut">
                    </label>
                    <label for="admin_event_fin">
                        <p>Fin: </p>
                        <input [(ngModel)]="dateFin" type="date" name="admin_event_fin" id="admin_event_fin">
                    </label>
                </div>
                <div class="buttons_ctn">
                    <button (click)="modify(evenement.evenementId)">Oui</button>
                    <button (click)="closeModifyModal()">Annuler</button>
                </div>
            </div>
        </div>
        <div class="deleteModal_ctn">
            <div class="deleteModal">
                <h3>Voulez-vous réelement supprimer l'évènement <b>{{evenement.name}}</b>?</h3>
                <div class="buttons_delete_ctn">
                    <button (click)="delete()">Oui</button>
                    <button (click)="closeDeleteModal()">Annuler</button>
                </div>
            </div>
        </div>
    </div>
</main>